import moment from "moment";
import React from "react";
import {
    loadFont,
    marketingCreativeColorSchemes,
    marketingCreativeTemplateKeys,
} from "ui/pages/marketing/MarketingCreatives/data";
import { handleDateFormat } from "utils/Utils";

export const ColvenStoryDetailed = (props) => {
    const { textData, coverImage } = props;

    const defaultColorScheme =
        marketingCreativeColorSchemes?.[marketingCreativeTemplateKeys.Colven]
            ?.schemes?.[0];

    const color1 = props?.colors?.[0] || defaultColorScheme?.[0];
    const color2 = props?.colors?.[1] || defaultColorScheme?.[1];
    const color3 = props?.colors?.[2] || defaultColorScheme?.[2];
    const color4 = props?.colors?.[3] || defaultColorScheme?.[3];

    const startDateExists = textData?.start_date_time?.exists;
    const startDate = startDateExists && textData?.start_date_time?.date;
    const startTime = startDateExists && textData?.start_date_time?.time;
    const endDateExists = textData?.end_date_time?.exists;
    const endDate = endDateExists && textData?.end_date_time?.date;
    const endTime = endDateExists && textData?.end_date_time?.time;

    React.useEffect(() => {
        loadFont(
            "https://fonts.googleapis.com/css2?family=Montserrat&display=swap"
        );
    }, []);

    return (
        <div style={{ fontFamily: "Montserrat" }}>
            {textData?.heading ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "105px",
                        left: "34px",
                        fontWeight: 800,
                        fontSize: "96px",
                        width: "876px",
                        wordBreak: "break-word",
                        textTransform: "uppercase",
                    }}
                >
                    {textData?.heading}
                </div>
            ) : null}
            {textData?.sub_heading ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "479px",
                        left: "34px",
                        fontWeight: 600,
                        fontSize: "40px",
                        width: "925px",
                        wordBreak: "break-word",
                    }}
                >
                    {textData?.sub_heading}
                </div>
            ) : null}
            {startDate ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "653px",
                        left: "34px",
                        fontWeight: 800,
                        fontSize: "48px",
                        width: "876px",
                        height: "169px",
                        backgroundColor: color3,
                        whiteSpace: "nowrap",
                    }}
                >
                    <svg
                        width="53"
                        height="53"
                        style={{
                            position: "absolute",
                            top: "55px",
                            left: "31px",
                        }}
                        viewBox="0 0 53 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="3"
                            y="10.8333"
                            width="47"
                            height="39.1667"
                            rx="2"
                            stroke={color2}
                            stroke-width="6"
                        />
                        <path
                            d="M3 23.8889L50 23.8889"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                        <path
                            d="M18.6689 36.9441H34.3356"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                        <path
                            d="M16.0557 3L16.0557 13.4444"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                        <path
                            d="M36.9443 3L36.9443 13.4444"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                    </svg>

                    <div
                        style={{
                            position: "absolute",
                            top: "25px",
                            left: "126px",
                            height: "118px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        {endDate ? (
                            <>
                                <div>{handleDateFormat(startDate, false, false)}</div>
                                <div>{handleDateFormat(endDate, false, false)}</div>
                            </>
                        ) : (
                            <div>{handleDateFormat(startDate, false)}</div>
                        )}
                    </div>
                    {startTime ? (
                        <>
                            <svg
                                style={{
                                    position: "absolute",
                                    top: "59px",
                                    left: "557px",
                                }}
                                width="53"
                                height="53"
                                viewBox="0 0 53 53"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="26.5"
                                    cy="26.5"
                                    r="23"
                                    stroke={color2}
                                    stroke-width="7"
                                />
                                <path
                                    d="M37.7277 27.0905H27.3413C27.2032 27.0905 27.0913 26.9786 27.0913 26.8405V17.636"
                                    stroke={color2}
                                    stroke-width="7"
                                    stroke-linecap="round"
                                />
                            </svg>
                            <div
                                style={{
                                    position: "absolute",
                                    top: "25px",
                                    left: "652px",
                                    height: "118px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                            >
                                {startTime ? <div>{startTime}</div> : null}
                                {endTime ? <div>{endTime}</div> : null}
                            </div>
                        </>
                    ) : null}
                    <svg
                        width="77"
                        height="35"
                        style={{
                            top: "125px",
                            left: "787px",
                            position: "absolute",
                        }}
                        viewBox="0 0 77 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M54.6959 34.6674C53.8469 34.1708 53.7486 33.2986 54.4763 32.7193L72.4634 18.3991C73.1133 17.8817 73.1133 17.1183 72.4634 16.6009L54.4763 2.28072C53.7486 1.70139 53.8469 0.829201 54.6959 0.33263C55.5449 -0.163937 56.823 -0.0968475 57.5507 0.482483L75.5378 14.8026C77.4874 16.3548 77.4874 18.6452 75.5378 20.1974L57.5507 34.5175C56.823 35.0968 55.5449 35.1639 54.6959 34.6674ZM27.7015 34.6674C26.8525 34.1708 26.7542 33.2986 27.4819 32.7193L45.469 18.3991C46.1189 17.8817 46.1189 17.1183 45.469 16.6009L27.4819 2.28072C26.7542 1.70139 26.8525 0.829201 27.7015 0.33263C28.5504 -0.163937 29.8286 -0.0968475 30.5562 0.482483L48.5433 14.8026C50.493 16.3548 50.493 18.6452 48.5434 20.1974L30.5562 34.5175C29.8286 35.0968 28.5504 35.1639 27.7015 34.6674ZM0.487442 32.7193C-0.240234 33.2986 -0.141922 34.1708 0.707039 34.6674C1.556 35.1639 2.83411 35.0968 3.5618 34.5175L21.5489 20.1974C23.4985 18.6452 23.4985 16.3548 21.5489 14.8026L3.5618 0.482483C2.83412 -0.0968475 1.556 -0.163937 0.707039 0.33263C-0.141922 0.829201 -0.240234 1.70139 0.487442 2.28072L18.4746 16.6009C19.1244 17.1183 19.1244 17.8817 18.4746 18.3991L0.487442 32.7193Z"
                            fill={color2}
                        />
                    </svg>
                </div>
            ) : null}
            {textData?.action_text ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        backgroundColor: color3,
                        top: "1634px",
                        left: "0px",
                        paddingLeft: "26px",
                        paddingRight: "26px",
                        wordBreak: "break-word",
                        height: "201px",
                        width: "411px",
                        fontWeight: 800,
                        fontSize: "64px",
                        textTransform: "uppercase",
                    }}
                >
                    {textData?.action_text}
                    <svg
                        width="130"
                        height="30"
                        style={{
                            position: "absolute",
                            top: "157px",
                            left: "326px",
                        }}
                        viewBox="0 0 130 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5 27.5C5 26.1193 3.88071 25 2.5 25C1.11929 25 0 26.1193 0 27.5C0 28.8807 1.11929 30 2.5 30C3.88071 30 5 28.8807 5 27.5ZM30 27.5C30 26.1193 28.8807 25 27.5 25C26.1193 25 25 26.1193 25 27.5C25 28.8807 26.1193 30 27.5 30C28.8807 30 30 28.8807 30 27.5ZM52.5 25C53.8807 25 55 26.1193 55 27.5C55 28.8807 53.8807 30 52.5 30C51.1193 30 50 28.8807 50 27.5C50 26.1193 51.1193 25 52.5 25ZM80 27.5C80 26.1193 78.8807 25 77.5 25C76.1193 25 75 26.1193 75 27.5C75 28.8807 76.1193 30 77.5 30C78.8807 30 80 28.8807 80 27.5ZM102.5 25C103.881 25 105 26.1193 105 27.5C105 28.8807 103.881 30 102.5 30C101.119 30 100 28.8807 100 27.5C100 26.1193 101.119 25 102.5 25ZM130 27.5C130 26.1193 128.881 25 127.5 25C126.119 25 125 26.1193 125 27.5C125 28.8807 126.119 30 127.5 30C128.881 30 130 28.8807 130 27.5ZM2.5 0C3.88071 0 5 1.11929 5 2.5C5 3.88071 3.88071 5 2.5 5C1.11929 5 0 3.88071 0 2.5C0 1.11929 1.11929 0 2.5 0ZM30 2.5C30 1.11929 28.8807 0 27.5 0C26.1193 0 25 1.11929 25 2.5C25 3.88071 26.1193 5 27.5 5C28.8807 5 30 3.88071 30 2.5ZM52.5 0C53.8807 0 55 1.11929 55 2.5C55 3.88071 53.8807 5 52.5 5C51.1193 5 50 3.88071 50 2.5C50 1.11929 51.1193 0 52.5 0ZM80 2.5C80 1.11929 78.8807 0 77.5 0C76.1193 0 75 1.11929 75 2.5C75 3.88071 76.1193 5 77.5 5C78.8807 5 80 3.88071 80 2.5ZM102.5 0C103.881 0 105 1.11929 105 2.5C105 3.88071 103.881 5 102.5 5C101.119 5 100 3.88071 100 2.5C100 1.11929 101.119 0 102.5 0ZM130 2.5C130 1.11929 128.881 0 127.5 0C126.119 0 125 1.11929 125 2.5C125 3.88071 126.119 5 127.5 5C128.881 5 130 3.88071 130 2.5Z"
                            fill={color4}
                        />
                    </svg>
                </div>
            ) : null}
            {textData?.additional_text ? (
                <div
                    style={{
                        position: "absolute",
                        color: color3,
                        top: "37px",
                        left: "50px",
                        fontWeight: 500,
                        fontSize: "24px",
                        whiteSpace: "nowrap",
                    }}
                >
                    {textData?.additional_text}
                </div>
            ) : null}
            {coverImage ? (
                <div
                    style={{
                        position: "absolute",
                        width: "610px",
                        height: "764px",
                        top: "1071px",
                        left: "439px",
                        backgroundImage: "url(" + coverImage + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                />
            ) : null}
            {textData?.details_list?.title ? (
                <div
                    style={{
                        position: "absolute",
                        color: color4,
                        top: "925px",
                        left: "34px",
                        fontWeight: 800,
                        fontSize: "48px",
                        whiteSpace: "nowrap",
                    }}
                >
                    {textData?.details_list?.title}
                </div>
            ) : null}
            {textData?.details_list?.data ? (
                <div
                    style={{
                        position: "absolute",
                        color: color4,
                        top: "1015px",
                        left: "34px",
                        fontWeight: 400,
                        fontSize: "40px",
                        whiteSpace: "nowrap",
                        zIndex: 1,
                    }}
                >
                    {textData?.details_list?.data?.map((item) => (
                        <div>{item}</div>
                    ))}
                </div>
            ) : null}

            <svg
                width="610"
                height="764"
                style={{
                    position: "absolute",
                    top: "1072px",
                    left: "439px",
                }}
                viewBox="0 0 610 764"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_15_2)">
                    <rect
                        width="610"
                        height="764"
                        fill={color1}
                        fill-opacity="0.25"
                    />
                    <line
                        x1="-42.3081"
                        y1="224.755"
                        x2="115.818"
                        y2="36.3081"
                        stroke={color2}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="347.692"
                        y1="856.755"
                        x2="505.818"
                        y2="668.308"
                        stroke={color2}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_15_2">
                        <rect width="610" height="764" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <svg
                width="1080"
                height="1920"
                viewBox="0 0 1080 1920"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_689_1801)">
                    <rect width="1080" height="1920" fill={color1} />
                    <rect y="875" width="966" height="1045" fill={color2} />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M71.6576 1204.94L70.5571 1201L69.4566 1204.94L65.3691 1206L69.4566 1207.06L70.5571 1211L71.6576 1207.06L75.7451 1206L71.6576 1204.94ZM71.6576 1294.94L70.5571 1291L69.4566 1294.94L65.3691 1296L69.4566 1297.06L70.5571 1301L71.6576 1297.06L75.7451 1296L71.6576 1294.94ZM70.5571 1381L71.6576 1384.94L75.7451 1386L71.6576 1387.06L70.5571 1391L69.4566 1387.06L65.3691 1386L69.4566 1384.94L70.5571 1381ZM71.6576 1474.94L70.5571 1471L69.4566 1474.94L65.3691 1476L69.4566 1477.06L70.5571 1481L71.6576 1477.06L75.7451 1476L71.6576 1474.94ZM163.941 1201L165.041 1204.94L169.129 1206L165.041 1207.06L163.941 1211L162.84 1207.06L158.753 1206L162.84 1204.94L163.941 1201ZM165.041 1294.94L163.941 1291L162.84 1294.94L158.753 1296L162.84 1297.06L163.941 1301L165.041 1297.06L169.129 1296L165.041 1294.94ZM163.941 1381L165.041 1384.94L169.129 1386L165.041 1387.06L163.941 1391L162.84 1387.06L158.753 1386L162.84 1384.94L163.941 1381ZM165.041 1474.94L163.941 1471L162.84 1474.94L158.753 1476L162.84 1477.06L163.941 1481L165.041 1477.06L169.129 1476L165.041 1474.94ZM257.324 1201L258.425 1204.94L262.512 1206L258.425 1207.06L257.324 1211L256.223 1207.06L252.136 1206L256.223 1204.94L257.324 1201ZM258.425 1294.94L257.324 1291L256.223 1294.94L252.136 1296L256.223 1297.06L257.324 1301L258.425 1297.06L262.512 1296L258.425 1294.94ZM257.324 1381L258.425 1384.94L262.512 1386L258.425 1387.06L257.324 1391L256.223 1387.06L252.136 1386L256.223 1384.94L257.324 1381ZM258.425 1474.94L257.324 1471L256.223 1474.94L252.136 1476L256.223 1477.06L257.324 1481L258.425 1477.06L262.512 1476L258.425 1474.94ZM350.707 1201L351.808 1204.94L355.895 1206L351.808 1207.06L350.707 1211L349.607 1207.06L345.52 1206L349.607 1204.94L350.707 1201ZM351.808 1294.94L350.707 1291L349.607 1294.94L345.52 1296L349.607 1297.06L350.707 1301L351.808 1297.06L355.895 1296L351.808 1294.94ZM350.707 1381L351.808 1384.94L355.895 1386L351.808 1387.06L350.707 1391L349.607 1387.06L345.52 1386L349.607 1384.94L350.707 1381ZM351.808 1474.94L350.707 1471L349.607 1474.94L345.52 1476L349.607 1477.06L350.707 1481L351.808 1477.06L355.895 1476L351.808 1474.94Z"
                        fill={color1}
                    />
                    <line
                        x1="777.692"
                        y1="1988.36"
                        x2="935.818"
                        y2="1799.91"
                        stroke={color1}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <circle cx="851.928" cy="1793" r="7" fill={color1} />
                    <rect
                        width="83"
                        height="764"
                        transform="translate(966 1071)"
                        fill={color4}
                    />
                    <rect
                        width="83"
                        height="764"
                        transform="translate(966 1071)"
                        fill={color1}
                    />
                    <rect
                        x="34"
                        y="567"
                        width="825"
                        height="15"
                        fill={color2}
                    />
                    <circle cx="874" cy="575" r="8" fill={color2} />
                    <circle cx="398" cy="1765" r="7" fill={color1} />
                    <line
                        x1="748.692"
                        y1="1087.47"
                        x2="945.385"
                        y2="853.062"
                        stroke={color1}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="310.692"
                        y1="1768.76"
                        x2="468.818"
                        y2="1580.31"
                        stroke={color1}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <g clip-path="url(#clip1_689_1801)">
                        <rect
                            width="527"
                            height="764"
                            transform="translate(439 1071)"
                            fill={color4}
                        />
                        <line
                            x1="396.692"
                            y1="1295.76"
                            x2="554.818"
                            y2="1107.31"
                            stroke={color2}
                            stroke-width="5"
                            stroke-linecap="round"
                        />
                        <line
                            x1="786.692"
                            y1="1927.76"
                            x2="944.818"
                            y2="1739.31"
                            stroke={color2}
                            stroke-width="5"
                            stroke-linecap="round"
                        />
                        <g clip-path="url(#clip2_689_1801)">
                            <rect
                                width="527"
                                height="764"
                                transform="translate(439 1071)"
                                fill={color1}
                                fill-opacity="0.4"
                            />
                            <line
                                x1="396.692"
                                y1="1295.76"
                                x2="554.818"
                                y2="1107.31"
                                stroke={color2}
                                stroke-width="5"
                                stroke-linecap="round"
                            />
                            <line
                                x1="786.692"
                                y1="1927.76"
                                x2="944.818"
                                y2="1739.31"
                                stroke={color2}
                                stroke-width="5"
                                stroke-linecap="round"
                            />
                        </g>
                    </g>
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M331 1818.5C331 1817.12 329.881 1816 328.5 1816C327.119 1816 326 1817.12 326 1818.5C326 1819.88 327.119 1821 328.5 1821C329.881 1821 331 1819.88 331 1818.5ZM356 1818.5C356 1817.12 354.881 1816 353.5 1816C352.119 1816 351 1817.12 351 1818.5C351 1819.88 352.119 1821 353.5 1821C354.881 1821 356 1819.88 356 1818.5ZM378.5 1816C379.881 1816 381 1817.12 381 1818.5C381 1819.88 379.881 1821 378.5 1821C377.119 1821 376 1819.88 376 1818.5C376 1817.12 377.119 1816 378.5 1816ZM406 1818.5C406 1817.12 404.881 1816 403.5 1816C402.119 1816 401 1817.12 401 1818.5C401 1819.88 402.119 1821 403.5 1821C404.881 1821 406 1819.88 406 1818.5ZM428.5 1816C429.881 1816 431 1817.12 431 1818.5C431 1819.88 429.881 1821 428.5 1821C427.119 1821 426 1819.88 426 1818.5C426 1817.12 427.119 1816 428.5 1816ZM456 1818.5C456 1817.12 454.881 1816 453.5 1816C452.119 1816 451 1817.12 451 1818.5C451 1819.88 452.119 1821 453.5 1821C454.881 1821 456 1819.88 456 1818.5ZM328.5 1791C329.881 1791 331 1792.12 331 1793.5C331 1794.88 329.881 1796 328.5 1796C327.119 1796 326 1794.88 326 1793.5C326 1792.12 327.119 1791 328.5 1791ZM356 1793.5C356 1792.12 354.881 1791 353.5 1791C352.119 1791 351 1792.12 351 1793.5C351 1794.88 352.119 1796 353.5 1796C354.881 1796 356 1794.88 356 1793.5ZM378.5 1791C379.881 1791 381 1792.12 381 1793.5C381 1794.88 379.881 1796 378.5 1796C377.119 1796 376 1794.88 376 1793.5C376 1792.12 377.119 1791 378.5 1791ZM406 1793.5C406 1792.12 404.881 1791 403.5 1791C402.119 1791 401 1792.12 401 1793.5C401 1794.88 402.119 1796 403.5 1796C404.881 1796 406 1794.88 406 1793.5ZM428.5 1791C429.881 1791 431 1792.12 431 1793.5C431 1794.88 429.881 1796 428.5 1796C427.119 1796 426 1794.88 426 1793.5C426 1792.12 427.119 1791 428.5 1791ZM456 1793.5C456 1792.12 454.881 1791 453.5 1791C452.119 1791 451 1792.12 451 1793.5C451 1794.88 452.119 1796 453.5 1796C454.881 1796 456 1794.88 456 1793.5Z"
                        fill={color4}
                    />
                    <line
                        x1="31.5"
                        y1="73.5"
                        x2="31.5"
                        y2="29.5"
                        stroke={color3}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <path
                        d="M915 73.5C915 74.8807 913.881 76 912.5 76C911.119 76 910 74.8807 910 73.5C910 72.1193 911.119 71 912.5 71C913.881 71 915 72.1193 915 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 73.5C930 74.8807 928.881 76 927.5 76C926.119 76 925 74.8807 925 73.5C925 72.1193 926.119 71 927.5 71C928.881 71 930 72.1193 930 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 73.5C945 74.8807 943.881 76 942.5 76C941.119 76 940 74.8807 940 73.5C940 72.1193 941.119 71 942.5 71C943.881 71 945 72.1193 945 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 73.5C960 74.8807 958.881 76 957.5 76C956.119 76 955 74.8807 955 73.5C955 72.1193 956.119 71 957.5 71C958.881 71 960 72.1193 960 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 73.5C975 74.8807 973.881 76 972.5 76C971.119 76 970 74.8807 970 73.5C970 72.1193 971.119 71 972.5 71C973.881 71 975 72.1193 975 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 73.5C990 74.8807 988.881 76 987.5 76C986.119 76 985 74.8807 985 73.5C985 72.1193 986.119 71 987.5 71C988.881 71 990 72.1193 990 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 73.5C1005 74.8807 1003.88 76 1002.5 76C1001.12 76 1000 74.8807 1000 73.5C1000 72.1193 1001.12 71 1002.5 71C1003.88 71 1005 72.1193 1005 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 73.5C1020 74.8807 1018.88 76 1017.5 76C1016.12 76 1015 74.8807 1015 73.5C1015 72.1193 1016.12 71 1017.5 71C1018.88 71 1020 72.1193 1020 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 73.5C1035 74.8807 1033.88 76 1032.5 76C1031.12 76 1030 74.8807 1030 73.5C1030 72.1193 1031.12 71 1032.5 71C1033.88 71 1035 72.1193 1035 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 73.5C1050 74.8807 1048.88 76 1047.5 76C1046.12 76 1045 74.8807 1045 73.5C1045 72.1193 1046.12 71 1047.5 71C1048.88 71 1050 72.1193 1050 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 73.5C1065 74.8807 1063.88 76 1062.5 76C1061.12 76 1060 74.8807 1060 73.5C1060 72.1193 1061.12 71 1062.5 71C1063.88 71 1065 72.1193 1065 73.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 88.5C915 89.8807 913.881 91 912.5 91C911.119 91 910 89.8807 910 88.5C910 87.1193 911.119 86 912.5 86C913.881 86 915 87.1193 915 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 88.5C930 89.8807 928.881 91 927.5 91C926.119 91 925 89.8807 925 88.5C925 87.1193 926.119 86 927.5 86C928.881 86 930 87.1193 930 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 88.5C945 89.8807 943.881 91 942.5 91C941.119 91 940 89.8807 940 88.5C940 87.1193 941.119 86 942.5 86C943.881 86 945 87.1193 945 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 88.5C960 89.8807 958.881 91 957.5 91C956.119 91 955 89.8807 955 88.5C955 87.1193 956.119 86 957.5 86C958.881 86 960 87.1193 960 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 88.5C975 89.8807 973.881 91 972.5 91C971.119 91 970 89.8807 970 88.5C970 87.1193 971.119 86 972.5 86C973.881 86 975 87.1193 975 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 88.5C990 89.8807 988.881 91 987.5 91C986.119 91 985 89.8807 985 88.5C985 87.1193 986.119 86 987.5 86C988.881 86 990 87.1193 990 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 88.5C1005 89.8807 1003.88 91 1002.5 91C1001.12 91 1000 89.8807 1000 88.5C1000 87.1193 1001.12 86 1002.5 86C1003.88 86 1005 87.1193 1005 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 88.5C1020 89.8807 1018.88 91 1017.5 91C1016.12 91 1015 89.8807 1015 88.5C1015 87.1193 1016.12 86 1017.5 86C1018.88 86 1020 87.1193 1020 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 88.5C1035 89.8807 1033.88 91 1032.5 91C1031.12 91 1030 89.8807 1030 88.5C1030 87.1193 1031.12 86 1032.5 86C1033.88 86 1035 87.1193 1035 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 88.5C1050 89.8807 1048.88 91 1047.5 91C1046.12 91 1045 89.8807 1045 88.5C1045 87.1193 1046.12 86 1047.5 86C1048.88 86 1050 87.1193 1050 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 88.5C1065 89.8807 1063.88 91 1062.5 91C1061.12 91 1060 89.8807 1060 88.5C1060 87.1193 1061.12 86 1062.5 86C1063.88 86 1065 87.1193 1065 88.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 103.5C915 104.881 913.881 106 912.5 106C911.119 106 910 104.881 910 103.5C910 102.119 911.119 101 912.5 101C913.881 101 915 102.119 915 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 103.5C930 104.881 928.881 106 927.5 106C926.119 106 925 104.881 925 103.5C925 102.119 926.119 101 927.5 101C928.881 101 930 102.119 930 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 103.5C945 104.881 943.881 106 942.5 106C941.119 106 940 104.881 940 103.5C940 102.119 941.119 101 942.5 101C943.881 101 945 102.119 945 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 103.5C960 104.881 958.881 106 957.5 106C956.119 106 955 104.881 955 103.5C955 102.119 956.119 101 957.5 101C958.881 101 960 102.119 960 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 103.5C975 104.881 973.881 106 972.5 106C971.119 106 970 104.881 970 103.5C970 102.119 971.119 101 972.5 101C973.881 101 975 102.119 975 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 103.5C990 104.881 988.881 106 987.5 106C986.119 106 985 104.881 985 103.5C985 102.119 986.119 101 987.5 101C988.881 101 990 102.119 990 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 103.5C1005 104.881 1003.88 106 1002.5 106C1001.12 106 1000 104.881 1000 103.5C1000 102.119 1001.12 101 1002.5 101C1003.88 101 1005 102.119 1005 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 103.5C1020 104.881 1018.88 106 1017.5 106C1016.12 106 1015 104.881 1015 103.5C1015 102.119 1016.12 101 1017.5 101C1018.88 101 1020 102.119 1020 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 103.5C1035 104.881 1033.88 106 1032.5 106C1031.12 106 1030 104.881 1030 103.5C1030 102.119 1031.12 101 1032.5 101C1033.88 101 1035 102.119 1035 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 103.5C1050 104.881 1048.88 106 1047.5 106C1046.12 106 1045 104.881 1045 103.5C1045 102.119 1046.12 101 1047.5 101C1048.88 101 1050 102.119 1050 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 103.5C1065 104.881 1063.88 106 1062.5 106C1061.12 106 1060 104.881 1060 103.5C1060 102.119 1061.12 101 1062.5 101C1063.88 101 1065 102.119 1065 103.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 118.5C915 119.881 913.881 121 912.5 121C911.119 121 910 119.881 910 118.5C910 117.119 911.119 116 912.5 116C913.881 116 915 117.119 915 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 118.5C930 119.881 928.881 121 927.5 121C926.119 121 925 119.881 925 118.5C925 117.119 926.119 116 927.5 116C928.881 116 930 117.119 930 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 118.5C945 119.881 943.881 121 942.5 121C941.119 121 940 119.881 940 118.5C940 117.119 941.119 116 942.5 116C943.881 116 945 117.119 945 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 118.5C960 119.881 958.881 121 957.5 121C956.119 121 955 119.881 955 118.5C955 117.119 956.119 116 957.5 116C958.881 116 960 117.119 960 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 118.5C975 119.881 973.881 121 972.5 121C971.119 121 970 119.881 970 118.5C970 117.119 971.119 116 972.5 116C973.881 116 975 117.119 975 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 118.5C990 119.881 988.881 121 987.5 121C986.119 121 985 119.881 985 118.5C985 117.119 986.119 116 987.5 116C988.881 116 990 117.119 990 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 118.5C1005 119.881 1003.88 121 1002.5 121C1001.12 121 1000 119.881 1000 118.5C1000 117.119 1001.12 116 1002.5 116C1003.88 116 1005 117.119 1005 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 118.5C1020 119.881 1018.88 121 1017.5 121C1016.12 121 1015 119.881 1015 118.5C1015 117.119 1016.12 116 1017.5 116C1018.88 116 1020 117.119 1020 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 118.5C1035 119.881 1033.88 121 1032.5 121C1031.12 121 1030 119.881 1030 118.5C1030 117.119 1031.12 116 1032.5 116C1033.88 116 1035 117.119 1035 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 118.5C1050 119.881 1048.88 121 1047.5 121C1046.12 121 1045 119.881 1045 118.5C1045 117.119 1046.12 116 1047.5 116C1048.88 116 1050 117.119 1050 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 118.5C1065 119.881 1063.88 121 1062.5 121C1061.12 121 1060 119.881 1060 118.5C1060 117.119 1061.12 116 1062.5 116C1063.88 116 1065 117.119 1065 118.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 133.5C915 134.881 913.881 136 912.5 136C911.119 136 910 134.881 910 133.5C910 132.119 911.119 131 912.5 131C913.881 131 915 132.119 915 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 133.5C930 134.881 928.881 136 927.5 136C926.119 136 925 134.881 925 133.5C925 132.119 926.119 131 927.5 131C928.881 131 930 132.119 930 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 133.5C945 134.881 943.881 136 942.5 136C941.119 136 940 134.881 940 133.5C940 132.119 941.119 131 942.5 131C943.881 131 945 132.119 945 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 133.5C960 134.881 958.881 136 957.5 136C956.119 136 955 134.881 955 133.5C955 132.119 956.119 131 957.5 131C958.881 131 960 132.119 960 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 133.5C975 134.881 973.881 136 972.5 136C971.119 136 970 134.881 970 133.5C970 132.119 971.119 131 972.5 131C973.881 131 975 132.119 975 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 133.5C990 134.881 988.881 136 987.5 136C986.119 136 985 134.881 985 133.5C985 132.119 986.119 131 987.5 131C988.881 131 990 132.119 990 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 133.5C1005 134.881 1003.88 136 1002.5 136C1001.12 136 1000 134.881 1000 133.5C1000 132.119 1001.12 131 1002.5 131C1003.88 131 1005 132.119 1005 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 133.5C1020 134.881 1018.88 136 1017.5 136C1016.12 136 1015 134.881 1015 133.5C1015 132.119 1016.12 131 1017.5 131C1018.88 131 1020 132.119 1020 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 133.5C1035 134.881 1033.88 136 1032.5 136C1031.12 136 1030 134.881 1030 133.5C1030 132.119 1031.12 131 1032.5 131C1033.88 131 1035 132.119 1035 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 133.5C1050 134.881 1048.88 136 1047.5 136C1046.12 136 1045 134.881 1045 133.5C1045 132.119 1046.12 131 1047.5 131C1048.88 131 1050 132.119 1050 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 133.5C1065 134.881 1063.88 136 1062.5 136C1061.12 136 1060 134.881 1060 133.5C1060 132.119 1061.12 131 1062.5 131C1063.88 131 1065 132.119 1065 133.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 148.5C915 149.881 913.881 151 912.5 151C911.119 151 910 149.881 910 148.5C910 147.119 911.119 146 912.5 146C913.881 146 915 147.119 915 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 148.5C930 149.881 928.881 151 927.5 151C926.119 151 925 149.881 925 148.5C925 147.119 926.119 146 927.5 146C928.881 146 930 147.119 930 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 148.5C945 149.881 943.881 151 942.5 151C941.119 151 940 149.881 940 148.5C940 147.119 941.119 146 942.5 146C943.881 146 945 147.119 945 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 148.5C960 149.881 958.881 151 957.5 151C956.119 151 955 149.881 955 148.5C955 147.119 956.119 146 957.5 146C958.881 146 960 147.119 960 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 148.5C975 149.881 973.881 151 972.5 151C971.119 151 970 149.881 970 148.5C970 147.119 971.119 146 972.5 146C973.881 146 975 147.119 975 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 148.5C990 149.881 988.881 151 987.5 151C986.119 151 985 149.881 985 148.5C985 147.119 986.119 146 987.5 146C988.881 146 990 147.119 990 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 148.5C1005 149.881 1003.88 151 1002.5 151C1001.12 151 1000 149.881 1000 148.5C1000 147.119 1001.12 146 1002.5 146C1003.88 146 1005 147.119 1005 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 148.5C1020 149.881 1018.88 151 1017.5 151C1016.12 151 1015 149.881 1015 148.5C1015 147.119 1016.12 146 1017.5 146C1018.88 146 1020 147.119 1020 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 148.5C1035 149.881 1033.88 151 1032.5 151C1031.12 151 1030 149.881 1030 148.5C1030 147.119 1031.12 146 1032.5 146C1033.88 146 1035 147.119 1035 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 148.5C1050 149.881 1048.88 151 1047.5 151C1046.12 151 1045 149.881 1045 148.5C1045 147.119 1046.12 146 1047.5 146C1048.88 146 1050 147.119 1050 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 148.5C1065 149.881 1063.88 151 1062.5 151C1061.12 151 1060 149.881 1060 148.5C1060 147.119 1061.12 146 1062.5 146C1063.88 146 1065 147.119 1065 148.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 163.5C915 164.881 913.881 166 912.5 166C911.119 166 910 164.881 910 163.5C910 162.119 911.119 161 912.5 161C913.881 161 915 162.119 915 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 163.5C930 164.881 928.881 166 927.5 166C926.119 166 925 164.881 925 163.5C925 162.119 926.119 161 927.5 161C928.881 161 930 162.119 930 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 163.5C945 164.881 943.881 166 942.5 166C941.119 166 940 164.881 940 163.5C940 162.119 941.119 161 942.5 161C943.881 161 945 162.119 945 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 163.5C960 164.881 958.881 166 957.5 166C956.119 166 955 164.881 955 163.5C955 162.119 956.119 161 957.5 161C958.881 161 960 162.119 960 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 163.5C975 164.881 973.881 166 972.5 166C971.119 166 970 164.881 970 163.5C970 162.119 971.119 161 972.5 161C973.881 161 975 162.119 975 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 163.5C990 164.881 988.881 166 987.5 166C986.119 166 985 164.881 985 163.5C985 162.119 986.119 161 987.5 161C988.881 161 990 162.119 990 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 163.5C1005 164.881 1003.88 166 1002.5 166C1001.12 166 1000 164.881 1000 163.5C1000 162.119 1001.12 161 1002.5 161C1003.88 161 1005 162.119 1005 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 163.5C1020 164.881 1018.88 166 1017.5 166C1016.12 166 1015 164.881 1015 163.5C1015 162.119 1016.12 161 1017.5 161C1018.88 161 1020 162.119 1020 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 163.5C1035 164.881 1033.88 166 1032.5 166C1031.12 166 1030 164.881 1030 163.5C1030 162.119 1031.12 161 1032.5 161C1033.88 161 1035 162.119 1035 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 163.5C1050 164.881 1048.88 166 1047.5 166C1046.12 166 1045 164.881 1045 163.5C1045 162.119 1046.12 161 1047.5 161C1048.88 161 1050 162.119 1050 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 163.5C1065 164.881 1063.88 166 1062.5 166C1061.12 166 1060 164.881 1060 163.5C1060 162.119 1061.12 161 1062.5 161C1063.88 161 1065 162.119 1065 163.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 178.5C915 179.881 913.881 181 912.5 181C911.119 181 910 179.881 910 178.5C910 177.119 911.119 176 912.5 176C913.881 176 915 177.119 915 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 178.5C930 179.881 928.881 181 927.5 181C926.119 181 925 179.881 925 178.5C925 177.119 926.119 176 927.5 176C928.881 176 930 177.119 930 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 178.5C945 179.881 943.881 181 942.5 181C941.119 181 940 179.881 940 178.5C940 177.119 941.119 176 942.5 176C943.881 176 945 177.119 945 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 178.5C960 179.881 958.881 181 957.5 181C956.119 181 955 179.881 955 178.5C955 177.119 956.119 176 957.5 176C958.881 176 960 177.119 960 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 178.5C975 179.881 973.881 181 972.5 181C971.119 181 970 179.881 970 178.5C970 177.119 971.119 176 972.5 176C973.881 176 975 177.119 975 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 178.5C990 179.881 988.881 181 987.5 181C986.119 181 985 179.881 985 178.5C985 177.119 986.119 176 987.5 176C988.881 176 990 177.119 990 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 178.5C1005 179.881 1003.88 181 1002.5 181C1001.12 181 1000 179.881 1000 178.5C1000 177.119 1001.12 176 1002.5 176C1003.88 176 1005 177.119 1005 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 178.5C1020 179.881 1018.88 181 1017.5 181C1016.12 181 1015 179.881 1015 178.5C1015 177.119 1016.12 176 1017.5 176C1018.88 176 1020 177.119 1020 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 178.5C1035 179.881 1033.88 181 1032.5 181C1031.12 181 1030 179.881 1030 178.5C1030 177.119 1031.12 176 1032.5 176C1033.88 176 1035 177.119 1035 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 178.5C1050 179.881 1048.88 181 1047.5 181C1046.12 181 1045 179.881 1045 178.5C1045 177.119 1046.12 176 1047.5 176C1048.88 176 1050 177.119 1050 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 178.5C1065 179.881 1063.88 181 1062.5 181C1061.12 181 1060 179.881 1060 178.5C1060 177.119 1061.12 176 1062.5 176C1063.88 176 1065 177.119 1065 178.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 193.5C915 194.881 913.881 196 912.5 196C911.119 196 910 194.881 910 193.5C910 192.119 911.119 191 912.5 191C913.881 191 915 192.119 915 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 193.5C930 194.881 928.881 196 927.5 196C926.119 196 925 194.881 925 193.5C925 192.119 926.119 191 927.5 191C928.881 191 930 192.119 930 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 193.5C945 194.881 943.881 196 942.5 196C941.119 196 940 194.881 940 193.5C940 192.119 941.119 191 942.5 191C943.881 191 945 192.119 945 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 193.5C960 194.881 958.881 196 957.5 196C956.119 196 955 194.881 955 193.5C955 192.119 956.119 191 957.5 191C958.881 191 960 192.119 960 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 193.5C975 194.881 973.881 196 972.5 196C971.119 196 970 194.881 970 193.5C970 192.119 971.119 191 972.5 191C973.881 191 975 192.119 975 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 193.5C990 194.881 988.881 196 987.5 196C986.119 196 985 194.881 985 193.5C985 192.119 986.119 191 987.5 191C988.881 191 990 192.119 990 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 193.5C1005 194.881 1003.88 196 1002.5 196C1001.12 196 1000 194.881 1000 193.5C1000 192.119 1001.12 191 1002.5 191C1003.88 191 1005 192.119 1005 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 193.5C1020 194.881 1018.88 196 1017.5 196C1016.12 196 1015 194.881 1015 193.5C1015 192.119 1016.12 191 1017.5 191C1018.88 191 1020 192.119 1020 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 193.5C1035 194.881 1033.88 196 1032.5 196C1031.12 196 1030 194.881 1030 193.5C1030 192.119 1031.12 191 1032.5 191C1033.88 191 1035 192.119 1035 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 193.5C1050 194.881 1048.88 196 1047.5 196C1046.12 196 1045 194.881 1045 193.5C1045 192.119 1046.12 191 1047.5 191C1048.88 191 1050 192.119 1050 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 193.5C1065 194.881 1063.88 196 1062.5 196C1061.12 196 1060 194.881 1060 193.5C1060 192.119 1061.12 191 1062.5 191C1063.88 191 1065 192.119 1065 193.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 208.5C915 209.881 913.881 211 912.5 211C911.119 211 910 209.881 910 208.5C910 207.119 911.119 206 912.5 206C913.881 206 915 207.119 915 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 208.5C930 209.881 928.881 211 927.5 211C926.119 211 925 209.881 925 208.5C925 207.119 926.119 206 927.5 206C928.881 206 930 207.119 930 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 208.5C945 209.881 943.881 211 942.5 211C941.119 211 940 209.881 940 208.5C940 207.119 941.119 206 942.5 206C943.881 206 945 207.119 945 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 208.5C960 209.881 958.881 211 957.5 211C956.119 211 955 209.881 955 208.5C955 207.119 956.119 206 957.5 206C958.881 206 960 207.119 960 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 208.5C975 209.881 973.881 211 972.5 211C971.119 211 970 209.881 970 208.5C970 207.119 971.119 206 972.5 206C973.881 206 975 207.119 975 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 208.5C990 209.881 988.881 211 987.5 211C986.119 211 985 209.881 985 208.5C985 207.119 986.119 206 987.5 206C988.881 206 990 207.119 990 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 208.5C1005 209.881 1003.88 211 1002.5 211C1001.12 211 1000 209.881 1000 208.5C1000 207.119 1001.12 206 1002.5 206C1003.88 206 1005 207.119 1005 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 208.5C1020 209.881 1018.88 211 1017.5 211C1016.12 211 1015 209.881 1015 208.5C1015 207.119 1016.12 206 1017.5 206C1018.88 206 1020 207.119 1020 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 208.5C1035 209.881 1033.88 211 1032.5 211C1031.12 211 1030 209.881 1030 208.5C1030 207.119 1031.12 206 1032.5 206C1033.88 206 1035 207.119 1035 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 208.5C1050 209.881 1048.88 211 1047.5 211C1046.12 211 1045 209.881 1045 208.5C1045 207.119 1046.12 206 1047.5 206C1048.88 206 1050 207.119 1050 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 208.5C1065 209.881 1063.88 211 1062.5 211C1061.12 211 1060 209.881 1060 208.5C1060 207.119 1061.12 206 1062.5 206C1063.88 206 1065 207.119 1065 208.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 223.5C915 224.881 913.881 226 912.5 226C911.119 226 910 224.881 910 223.5C910 222.119 911.119 221 912.5 221C913.881 221 915 222.119 915 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 223.5C930 224.881 928.881 226 927.5 226C926.119 226 925 224.881 925 223.5C925 222.119 926.119 221 927.5 221C928.881 221 930 222.119 930 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 223.5C945 224.881 943.881 226 942.5 226C941.119 226 940 224.881 940 223.5C940 222.119 941.119 221 942.5 221C943.881 221 945 222.119 945 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 223.5C960 224.881 958.881 226 957.5 226C956.119 226 955 224.881 955 223.5C955 222.119 956.119 221 957.5 221C958.881 221 960 222.119 960 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 223.5C975 224.881 973.881 226 972.5 226C971.119 226 970 224.881 970 223.5C970 222.119 971.119 221 972.5 221C973.881 221 975 222.119 975 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 223.5C990 224.881 988.881 226 987.5 226C986.119 226 985 224.881 985 223.5C985 222.119 986.119 221 987.5 221C988.881 221 990 222.119 990 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 223.5C1005 224.881 1003.88 226 1002.5 226C1001.12 226 1000 224.881 1000 223.5C1000 222.119 1001.12 221 1002.5 221C1003.88 221 1005 222.119 1005 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 223.5C1020 224.881 1018.88 226 1017.5 226C1016.12 226 1015 224.881 1015 223.5C1015 222.119 1016.12 221 1017.5 221C1018.88 221 1020 222.119 1020 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 223.5C1035 224.881 1033.88 226 1032.5 226C1031.12 226 1030 224.881 1030 223.5C1030 222.119 1031.12 221 1032.5 221C1033.88 221 1035 222.119 1035 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 223.5C1050 224.881 1048.88 226 1047.5 226C1046.12 226 1045 224.881 1045 223.5C1045 222.119 1046.12 221 1047.5 221C1048.88 221 1050 222.119 1050 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 223.5C1065 224.881 1063.88 226 1062.5 226C1061.12 226 1060 224.881 1060 223.5C1060 222.119 1061.12 221 1062.5 221C1063.88 221 1065 222.119 1065 223.5Z"
                        fill={color2}
                    />
                    <path
                        d="M915 238.5C915 239.881 913.881 241 912.5 241C911.119 241 910 239.881 910 238.5C910 237.119 911.119 236 912.5 236C913.881 236 915 237.119 915 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M930 238.5C930 239.881 928.881 241 927.5 241C926.119 241 925 239.881 925 238.5C925 237.119 926.119 236 927.5 236C928.881 236 930 237.119 930 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M945 238.5C945 239.881 943.881 241 942.5 241C941.119 241 940 239.881 940 238.5C940 237.119 941.119 236 942.5 236C943.881 236 945 237.119 945 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M960 238.5C960 239.881 958.881 241 957.5 241C956.119 241 955 239.881 955 238.5C955 237.119 956.119 236 957.5 236C958.881 236 960 237.119 960 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M975 238.5C975 239.881 973.881 241 972.5 241C971.119 241 970 239.881 970 238.5C970 237.119 971.119 236 972.5 236C973.881 236 975 237.119 975 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M990 238.5C990 239.881 988.881 241 987.5 241C986.119 241 985 239.881 985 238.5C985 237.119 986.119 236 987.5 236C988.881 236 990 237.119 990 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1005 238.5C1005 239.881 1003.88 241 1002.5 241C1001.12 241 1000 239.881 1000 238.5C1000 237.119 1001.12 236 1002.5 236C1003.88 236 1005 237.119 1005 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1020 238.5C1020 239.881 1018.88 241 1017.5 241C1016.12 241 1015 239.881 1015 238.5C1015 237.119 1016.12 236 1017.5 236C1018.88 236 1020 237.119 1020 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1035 238.5C1035 239.881 1033.88 241 1032.5 241C1031.12 241 1030 239.881 1030 238.5C1030 237.119 1031.12 236 1032.5 236C1033.88 236 1035 237.119 1035 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1050 238.5C1050 239.881 1048.88 241 1047.5 241C1046.12 241 1045 239.881 1045 238.5C1045 237.119 1046.12 236 1047.5 236C1048.88 236 1050 237.119 1050 238.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1065 238.5C1065 239.881 1063.88 241 1062.5 241C1061.12 241 1060 239.881 1060 238.5C1060 237.119 1061.12 236 1062.5 236C1063.88 236 1065 237.119 1065 238.5Z"
                        fill={color2}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_689_1801">
                        <rect width="1080" height="1920" fill={color4} />
                    </clipPath>
                    <clipPath id="clip1_689_1801">
                        <rect
                            width="527"
                            height="764"
                            fill={color4}
                            transform="translate(439 1071)"
                        />
                    </clipPath>
                    <clipPath id="clip2_689_1801">
                        <rect
                            width="527"
                            height="764"
                            fill={color4}
                            transform="translate(439 1071)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};
